import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'

const credentialTypes = ['authentication-key'] as const

export type usiwCredType = (typeof credentialTypes)[number]

export const usiwDocumentTypes = [
  'customs-documents',
  'inspection-certificate',
  'invoice',
  'letter-of-authority',
  'lumper-certificate',
  'packing-slip',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const usiw: CarrierDef<usiwCredType> = {
  name: 'Unisource Shipping',
  scac: 'usiw',
  credentialTypes,
  legacyCredMap: [['authentication-key', 'apiKey']],
  engineLayers: ['rating', 'pickup', 'documents', 'tracking'],
  documentTypes: usiwDocumentTypes,
  credentialConfig: {
    'authentication-key': { customerIdentifier: true },
  },
}
